module.exports = __webpack_public_path__ + "static/media/bike.7cc97c8f.png";